
app.controller('dialog_removeTemplateCtrl', ['$rootScope', '$scope', '$rootScope', '$http', 'NetworkService', 'MainService', 'Notification', function ($rootScope, $scope, $http, NetworkService, MainService, Notification) {

        $scope.notRemovableTemplates = ["registrierung",
        "Position Bestätigung"]
        $rootScope.$on("updateRemoveTemplate", function (event, template) {
            $scope.template = template;
        })

        $scope.info = function (msg) {
            Notification.info(msg);
        };

        $scope.removeTemplate = function () {
            if ($scope.notRemovableTemplates.indexOf($scope.template.Templatename) == -1)
            {
                NetworkService.removeTemplate($scope.template, function () {
                    $rootScope.$emit("repaint");
                })
            } else
            {
                $scope.info("Dieses Template kann nicht gelöscht werden")
            }
        }
    }])